// (() => {
//   const root = document.querySelector('[data-product-story-sticky]');
//   if (!root) return;

//   if (root.parentElement !== document.body) {
//     document.body.appendChild(root);
//   }

//   const getAtcTrigger = () =>
//     document.querySelector('product-info[id^="MainProduct-"] .product-form__submit') ||
//     document.querySelector('product-info[id^="MainProduct-"] [data-product-story-sticky-trigger]') ||
//     document.querySelector('product-info .product-form__submit');

//   const priceEl = root.querySelector('.product-story-sticky__price');
//   const stepper = root.querySelector('[data-product-story-sticky-stepper]');
//   const submitBtn = root.querySelector('product-form [type="submit"]');
//   const submitLabel = submitBtn?.querySelector('.visually-hidden');
//   const addLabelEl = root.querySelector('[data-product-story-sticky-add-label]');
//   const qtyEl = root.querySelector('[data-product-story-sticky-qty]');
//   const decBtn = root.querySelector('[data-product-story-sticky-dec]');

//   const getVariantInput = () => root.querySelector('product-form input[name="id"]');

//   const getMainProductSectionId = () => {
//     const pi = document.querySelector('product-info');
//     return pi?.dataset.section || null;
//   };

//   /**
//    * Section IDs for `/cart/change.js`. The theme can include both `cart-notification` (header) and
//    * `cart-drawer` (body); `querySelector('cart-notification')` must not win alone or the request
//    * omits `cart-drawer` and the drawer never gets empty-state HTML / `is-empty`.
//    */
//   const getSectionsForCartRequest = () => {
//     const ids = [];
//     const seen = new Set();
//     const pushFrom = (el) => {
//       if (!el || typeof el.getSectionsToRender !== 'function') return;
//       el.getSectionsToRender().forEach((s) => {
//         if (s?.id && !seen.has(s.id)) {
//           seen.add(s.id);
//           ids.push(s.id);
//         }
//       });
//     };
//     pushFrom(document.querySelector('cart-drawer'));
//     pushFrom(document.querySelector('cart-notification'));
//     if (ids.length) return ids;
//     return ['cart-drawer', 'cart-icon-bubble'];
//   };

//   const renderCartSectionsFromResponse = (parsedState) => {
//     if (!parsedState?.sections) return;

//     const drawer = document.querySelector('cart-drawer');
//     if (drawer && typeof drawer.renderContents === 'function' && parsedState.sections['cart-drawer']) {
//       try {
//         drawer.renderContents(parsedState);
//         const count =
//           typeof parsedState.item_count === 'number'
//             ? parsedState.item_count
//             : Array.isArray(parsedState.items)
//               ? parsedState.items.length
//               : 0;
//         drawer.classList.toggle('is-empty', count === 0);
//       } catch (e) {
//         console.error(e);
//       }
//     }

//     const notification = document.querySelector('cart-notification');
//     if (
//       notification &&
//       typeof notification.renderContents === 'function' &&
//       parsedState.key &&
//       (parsedState.sections['cart-notification-product'] || parsedState.sections['cart-notification-button'])
//     ) {
//       try {
//         notification.renderContents(parsedState);
//       } catch (e) {
//         console.error(e);
//       }
//     }
//   };

//   const sumQtyForVariant = (items, variantId) => {
//     if (!items?.length || variantId == null || variantId === '') return 0;
//     const id = Number(variantId);
//     return items.reduce((sum, line) => {
//       if (Number(line.variant_id) !== id) return sum;
//       return sum + (Number(line.quantity) || 0);
//     }, 0);
//   };

//   const updateQtyDisplay = (qty) => {
//     const n = Number(qty) || 0;
//     if (qtyEl) {
//       qtyEl.textContent = n > 0 ? String(n) : '';
//       qtyEl.setAttribute('aria-hidden', n > 0 ? 'false' : 'true');
//     }
//     if (stepper) {
//       stepper.classList.toggle('product-story-sticky__stepper--has-line-qty', n > 0);
//     }
//     if (decBtn) {
//       const soldOut = decBtn.hasAttribute('data-story-sold-out');
//       decBtn.disabled = soldOut || n < 1;
//     }
//     if (submitBtn) {
//       const base = submitBtn.getAttribute('data-add-to-cart-label') || submitLabel?.textContent?.trim() || '';
//       const increaseAria = submitBtn.getAttribute('data-aria-label-increase') || '';
//       if (n > 0 && increaseAria) {
//         submitBtn.setAttribute('aria-label', increaseAria);
//       } else {
//         submitBtn.setAttribute('aria-label', base);
//       }
//     }
//     if (addLabelEl && submitBtn) {
//       addLabelEl.textContent =
//         submitBtn.getAttribute('data-add-to-cart-label') || submitLabel?.textContent?.trim() || '';
//     }
//   };

//   const refreshCartQtyForCurrentVariant = () => {
//     const variantInput = getVariantInput();
//     const vid = variantInput?.value;
//     if (!vid) {
//       updateQtyDisplay(0);
//       return;
//     }
//     const url = (window.routes && window.routes.cart_url) || '/cart';
//     fetch(`${url}.js`)
//       .then((r) => {
//         if (!r.ok) throw new Error('cart');
//         return r.json();
//       })
//       .then((cart) => updateQtyDisplay(sumQtyForVariant(cart?.items, vid)))
//       .catch(() => updateQtyDisplay(0));
//   };

//   const applyCartChangeAndSync = (line, quantity) => {
//     const changeUrl = window.routes && window.routes.cart_change_url;
//     if (!changeUrl || typeof fetchConfig === 'undefined') return Promise.resolve();

//     const body = JSON.stringify({
//       line,
//       quantity,
//       sections: getSectionsForCartRequest(),
//       sections_url: window.location.pathname,
//     });

//     return fetch(changeUrl, { ...fetchConfig(), body })
//       .then((response) => response.text())
//       .then((text) => {
//         const parsedState = JSON.parse(text);
//         if (parsedState.errors) return;

//         renderCartSectionsFromResponse(parsedState);

//         if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
//           publish(PUB_SUB_EVENTS.cartUpdate, {
//             source: 'product-story-sticky',
//             cartData: parsedState,
//             productVariantId: getVariantInput()?.value,
//           });
//         }
//       });
//   };

//   const onDecClick = () => {
//     const variantInput = getVariantInput();
//     if (!decBtn || decBtn.disabled || !variantInput) return;
//     const vid = variantInput.value;
//     if (!vid) return;

//     decBtn.classList.add('loading');
//     decBtn.setAttribute('aria-busy', 'true');

//     const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
//     fetch(`${cartUrl}.js`)
//       .then((r) => r.json())
//       .then((cart) => {
//         const idx = cart.items.findIndex((item) => Number(item.variant_id) === Number(vid));
//         if (idx === -1) return;
//         const line = idx + 1;
//         const item = cart.items[idx];
//         const nextQty = Math.max(0, (Number(item.quantity) || 0) - 1);
//         return applyCartChangeAndSync(line, nextQty);
//       })
//       .catch(() => {})
//       .finally(() => {
//         decBtn.classList.remove('loading');
//         decBtn.removeAttribute('aria-busy');
//         refreshCartQtyForCurrentVariant();
//       });
//   };

//   if (decBtn) decBtn.addEventListener('click', onDecClick);

//   const syncFromVariantEvent = (event) => {
//     const d = event?.data;
//     if (!d || !d.variant) return;
//     const mainId = getMainProductSectionId();
//     if (!mainId || d.sectionId !== mainId) return;

//     const variantInput = getVariantInput();
//     if (variantInput) {
//       variantInput.value = d.variant.id;
//       variantInput.toggleAttribute('disabled', !d.variant.available);
//     }

//     if (priceEl && d.html) {
//       const src = d.html.getElementById(`price-${mainId}`);
//       if (src) priceEl.innerHTML = src.innerHTML;
//     }

//     if (submitBtn && d.html) {
//       const mainBtn = d.html.getElementById(`ProductSubmitButton-${mainId}`);
//       const soldOut = mainBtn?.hasAttribute('disabled') ?? true;
//       submitBtn.toggleAttribute('disabled', soldOut);
//       submitBtn.toggleAttribute('data-story-sold-out', soldOut);
//       if (decBtn) {
//         decBtn.toggleAttribute('disabled', soldOut);
//         decBtn.toggleAttribute('data-story-sold-out', soldOut);
//       }
//       const mainLabelSpan = mainBtn?.querySelector('span');
//       if (submitLabel && mainLabelSpan) {
//         const inner = mainLabelSpan.querySelector('.product-story-sticky__submit-text');
//         submitLabel.textContent = inner ? inner.textContent : mainLabelSpan.textContent;
//       }
//       if (submitBtn && submitLabel) {
//         submitBtn.setAttribute('data-add-to-cart-label', submitLabel.textContent.trim());
//       }
//       if (addLabelEl && submitLabel) {
//         addLabelEl.textContent = submitLabel.textContent.trim();
//       }
//     }

//     refreshCartQtyForCurrentVariant();
//   };

//   /**
//    * Show the sticky bar as soon as the main add-to-cart button is no longer
//    * visible in the viewport (scrolled away or covered). Hide it when the
//    * button is actually visible again.
//    */
//   let stickyRaf = 0;
//   let atcObserver = null;

//   const isAtcVisibleToUser = (trigger) => {
//     const rect = trigger.getBoundingClientRect();
//     const vh = window.innerHeight || document.documentElement.clientHeight;
//     const vw = window.innerWidth || document.documentElement.clientWidth;

//     if (rect.bottom <= 0 || rect.top >= vh || rect.right <= 0 || rect.left >= vw) {
//       return false;
//     }

//     const x = Math.min(vw - 1, Math.max(1, rect.left + rect.width / 2));
//     const y = Math.min(vh - 1, Math.max(1, rect.top + rect.height / 2));
//     const hit = document.elementFromPoint(x, y);
//     if (!hit) return false;
//     if (hit.closest('[data-product-story-sticky]')) return false;
//     return trigger === hit || trigger.contains(hit);
//   };

//   const updateStickyVisibility = () => {
//     const trigger = getAtcTrigger();
//     if (!trigger) {
//       root.classList.remove('is-visible');
//       root.setAttribute('aria-hidden', 'true');
//       return;
//     }

//     const stickyArmed = !isAtcVisibleToUser(trigger);

//     root.classList.toggle('is-visible', stickyArmed);
//     root.setAttribute('aria-hidden', stickyArmed ? 'false' : 'true');
//   };

//   const onScrollOrResize = () => {
//     cancelAnimationFrame(stickyRaf);
//     stickyRaf = requestAnimationFrame(updateStickyVisibility);
//   };

//   const observeAtc = () => {
//     const trigger = getAtcTrigger();
//     if (!trigger || typeof IntersectionObserver === 'undefined') return;

//     if (atcObserver) atcObserver.disconnect();
//     atcObserver = new IntersectionObserver(onScrollOrResize, {
//       threshold: 0,
//       root: null,
//     });
//     atcObserver.observe(trigger);
//   };

//   window.addEventListener('scroll', onScrollOrResize, { passive: true });
//   window.addEventListener('resize', onScrollOrResize);
//   observeAtc();
//   updateStickyVisibility();

//   refreshCartQtyForCurrentVariant();

//   if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
//     subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
//       syncFromVariantEvent(event);
//       observeAtc();
//       updateStickyVisibility();
//     });
//     subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
//       refreshCartQtyForCurrentVariant();
//     });
//   }
// })();

// (() => {
//   const root = document.querySelector('[data-product-story-sticky]');
//   if (!root) return;

//   const story = document.getElementById(root.dataset.storyRootId);
//   if (!story) return;

//   const priceEl = root.querySelector('.product-story-sticky__price');
//   const stepper = root.querySelector('[data-product-story-sticky-stepper]');
//   const submitBtn = root.querySelector('product-form [type="submit"]');
//   const submitLabel = submitBtn?.querySelector('.visually-hidden');
//   const addLabelEl = root.querySelector('[data-product-story-sticky-add-label]');
//   const qtyEl = root.querySelector('[data-product-story-sticky-qty]');
//   const decBtn = root.querySelector('[data-product-story-sticky-dec]');

//   const getVariantInput = () => root.querySelector('product-form input[name="id"]');

//   const getMainProductSectionId = () => {
//     const pi = document.querySelector('product-info');
//     return pi?.dataset.section || null;
//   };

//   /**
//    * Section IDs for `/cart/change.js`. The theme can include both `cart-notification` (header) and
//    * `cart-drawer` (body); `querySelector('cart-notification')` must not win alone or the request
//    * omits `cart-drawer` and the drawer never gets empty-state HTML / `is-empty`.
//    */
//   const getSectionsForCartRequest = () => {
//     const ids = [];
//     const seen = new Set();
//     const pushFrom = (el) => {
//       if (!el || typeof el.getSectionsToRender !== 'function') return;
//       el.getSectionsToRender().forEach((s) => {
//         if (s?.id && !seen.has(s.id)) {
//           seen.add(s.id);
//           ids.push(s.id);
//         }
//       });
//     };
//     pushFrom(document.querySelector('cart-drawer'));
//     pushFrom(document.querySelector('cart-notification'));
//     if (ids.length) return ids;
//     return ['cart-drawer', 'cart-icon-bubble'];
//   };

//   const renderCartSectionsFromResponse = (parsedState) => {
//     if (!parsedState?.sections) return;

//     const drawer = document.querySelector('cart-drawer');
//     if (drawer && typeof drawer.renderContents === 'function' && parsedState.sections['cart-drawer']) {
//       try {
//         drawer.renderContents(parsedState);
//         const count =
//           typeof parsedState.item_count === 'number'
//             ? parsedState.item_count
//             : Array.isArray(parsedState.items)
//               ? parsedState.items.length
//               : 0;
//         drawer.classList.toggle('is-empty', count === 0);
//       } catch (e) {
//         console.error(e);
//       }
//     }

//     const notification = document.querySelector('cart-notification');
//     if (
//       notification &&
//       typeof notification.renderContents === 'function' &&
//       parsedState.key &&
//       (parsedState.sections['cart-notification-product'] || parsedState.sections['cart-notification-button'])
//     ) {
//       try {
//         notification.renderContents(parsedState);
//       } catch (e) {
//         console.error(e);
//       }
//     }
//   };

//   const sumQtyForVariant = (items, variantId) => {
//     if (!items?.length || variantId == null || variantId === '') return 0;
//     const id = Number(variantId);
//     return items.reduce((sum, line) => {
//       if (Number(line.variant_id) !== id) return sum;
//       return sum + (Number(line.quantity) || 0);
//     }, 0);
//   };

//   const updateQtyDisplay = (qty) => {
//     const n = Number(qty) || 0;
//     if (qtyEl) {
//       qtyEl.textContent = n > 0 ? String(n) : '';
//       qtyEl.setAttribute('aria-hidden', n > 0 ? 'false' : 'true');
//     }
//     if (stepper) {
//       stepper.classList.toggle('product-story-sticky__stepper--has-line-qty', n > 0);
//     }
//     if (decBtn) {
//       const soldOut = decBtn.hasAttribute('data-story-sold-out');
//       decBtn.disabled = soldOut || n < 1;
//     }
//     if (submitBtn) {
//       const base = submitBtn.getAttribute('data-add-to-cart-label') || submitLabel?.textContent?.trim() || '';
//       const increaseAria = submitBtn.getAttribute('data-aria-label-increase') || '';
//       if (n > 0 && increaseAria) {
//         submitBtn.setAttribute('aria-label', increaseAria);
//       } else {
//         submitBtn.setAttribute('aria-label', base);
//       }
//     }
//     if (addLabelEl && submitBtn) {
//       addLabelEl.textContent =
//         submitBtn.getAttribute('data-add-to-cart-label') || submitLabel?.textContent?.trim() || '';
//     }
//   };

//   const refreshCartQtyForCurrentVariant = () => {
//     const variantInput = getVariantInput();
//     const vid = variantInput?.value;
//     if (!vid) {
//       updateQtyDisplay(0);
//       return;
//     }
//     const url = (window.routes && window.routes.cart_url) || '/cart';
//     fetch(`${url}.js`)
//       .then((r) => {
//         if (!r.ok) throw new Error('cart');
//         return r.json();
//       })
//       .then((cart) => updateQtyDisplay(sumQtyForVariant(cart?.items, vid)))
//       .catch(() => updateQtyDisplay(0));
//   };

//   const applyCartChangeAndSync = (line, quantity) => {
//     const changeUrl = window.routes && window.routes.cart_change_url;
//     if (!changeUrl || typeof fetchConfig === 'undefined') return Promise.resolve();

//     const body = JSON.stringify({
//       line,
//       quantity,
//       sections: getSectionsForCartRequest(),
//       sections_url: window.location.pathname,
//     });

//     return fetch(changeUrl, { ...fetchConfig(), body })
//       .then((response) => response.text())
//       .then((text) => {
//         const parsedState = JSON.parse(text);
//         if (parsedState.errors) return;

//         renderCartSectionsFromResponse(parsedState);

//         if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
//           publish(PUB_SUB_EVENTS.cartUpdate, {
//             source: 'product-story-sticky',
//             cartData: parsedState,
//             productVariantId: getVariantInput()?.value,
//           });
//         }
//       });
//   };

//   const onDecClick = () => {
//     const variantInput = getVariantInput();
//     if (!decBtn || decBtn.disabled || !variantInput) return;
//     const vid = variantInput.value;
//     if (!vid) return;

//     decBtn.classList.add('loading');
//     decBtn.setAttribute('aria-busy', 'true');

//     const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
//     fetch(`${cartUrl}.js`)
//       .then((r) => r.json())
//       .then((cart) => {
//         const idx = cart.items.findIndex((item) => Number(item.variant_id) === Number(vid));
//         if (idx === -1) return;
//         const line = idx + 1;
//         const item = cart.items[idx];
//         const nextQty = Math.max(0, (Number(item.quantity) || 0) - 1);
//         return applyCartChangeAndSync(line, nextQty);
//       })
//       .catch(() => {})
//       .finally(() => {
//         decBtn.classList.remove('loading');
//         decBtn.removeAttribute('aria-busy');
//         refreshCartQtyForCurrentVariant();
//       });
//   };

//   if (decBtn) decBtn.addEventListener('click', onDecClick);

//   const syncFromVariantEvent = (event) => {
//     const d = event?.data;
//     if (!d || !d.variant) return;
//     const mainId = getMainProductSectionId();
//     if (!mainId || d.sectionId !== mainId) return;

//     const variantInput = getVariantInput();
//     if (variantInput) {
//       variantInput.value = d.variant.id;
//       variantInput.toggleAttribute('disabled', !d.variant.available);
//     }

//     if (priceEl && d.html) {
//       const src = d.html.getElementById(`price-${mainId}`);
//       if (src) priceEl.innerHTML = src.innerHTML;
//     }

//     if (submitBtn && d.html) {
//       const mainBtn = d.html.getElementById(`ProductSubmitButton-${mainId}`);
//       const soldOut = mainBtn?.hasAttribute('disabled') ?? true;
//       submitBtn.toggleAttribute('disabled', soldOut);
//       submitBtn.toggleAttribute('data-story-sold-out', soldOut);
//       if (decBtn) {
//         decBtn.toggleAttribute('disabled', soldOut);
//         decBtn.toggleAttribute('data-story-sold-out', soldOut);
//       }
//       const mainLabelSpan = mainBtn?.querySelector('span');
//       if (submitLabel && mainLabelSpan) {
//         const inner = mainLabelSpan.querySelector('.product-story-sticky__submit-text');
//         submitLabel.textContent = inner ? inner.textContent : mainLabelSpan.textContent;
//       }
//       if (submitBtn && submitLabel) {
//         submitBtn.setAttribute('data-add-to-cart-label', submitLabel.textContent.trim());
//       }
//       if (addLabelEl && submitLabel) {
//         addLabelEl.textContent = submitLabel.textContent.trim();
//       }
//     }

//     refreshCartQtyForCurrentVariant();
//   };

//   /**
//    * Hidden until the user scrolls down to the product-story section.
//    * Once that section has entered the viewport, the bar stays visible for the rest of the page.
//    * Scrolling back above the story (section entirely below the fold again) hides it.
//    */
//   let stickyArmed = false;
//   let stickyRaf = 0;

//   const updateStickyVisibility = () => {
//     const rect = story.getBoundingClientRect();
//     const vh = window.innerHeight;

//     if (rect.top < vh && rect.bottom > 0) {
//       stickyArmed = true;
//     }
//     if (rect.top >= vh) {
//       stickyArmed = false;
//     }

//     root.classList.toggle('is-visible', stickyArmed);
//     root.setAttribute('aria-hidden', stickyArmed ? 'false' : 'true');
//   };

//   const onScrollOrResize = () => {
//     cancelAnimationFrame(stickyRaf);
//     stickyRaf = requestAnimationFrame(updateStickyVisibility);
//   };

//   window.addEventListener('scroll', onScrollOrResize, { passive: true });
//   window.addEventListener('resize', onScrollOrResize);
//   updateStickyVisibility();

//   refreshCartQtyForCurrentVariant();

//   if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
//     subscribe(PUB_SUB_EVENTS.variantChange, syncFromVariantEvent);
//     subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
//       refreshCartQtyForCurrentVariant();
//     });
//   }
// })();


(() => {
  const root = document.querySelector('[data-product-story-sticky]');
  if (!root) return;

  if (root.parentElement !== document.body) {
    document.body.appendChild(root);
  }

  const getAtcTrigger = () =>
    document.querySelector('product-info[id^="MainProduct-"] .product-form__submit') ||
    document.querySelector('product-info[id^="MainProduct-"] [data-product-story-sticky-trigger]') ||
    document.querySelector('product-info .product-form__submit');

  const priceEl = root.querySelector('.product-story-sticky__price');
  const submitPriceEl = root.querySelector('[data-product-story-sticky-submit-price]');
  const stepper = root.querySelector('[data-product-story-sticky-stepper]');
  const submitBtn = root.querySelector('product-form [type="submit"]');
  const submitLabel = submitBtn?.querySelector('.visually-hidden');
  const addLabelEl = root.querySelector('[data-product-story-sticky-add-label]');
  const qtyEl = root.querySelector('[data-product-story-sticky-qty]');
  const decBtn = root.querySelector('[data-product-story-sticky-dec]');

  const getVariantInput = () => root.querySelector('product-form input[name="id"]');

  const syncSubmitPriceFromPriceEl = () => {
    if (!submitPriceEl || !priceEl) return;
    const sale = priceEl.querySelector('.price-item--sale');
    const last = priceEl.querySelector('.price-item--last');
    const regular = priceEl.querySelector('.price-item--regular');
    const source = sale || last || regular || priceEl.querySelector('.price-item');
    submitPriceEl.textContent = source ? source.textContent.trim() : '';
  };

  const getMainProductSectionId = () => {
    const pi = document.querySelector('product-info');
    return pi?.dataset.section || null;
  };

  /**
   * Section IDs for `/cart/change.js`. The theme can include both `cart-notification` (header) and
   * `cart-drawer` (body); `querySelector('cart-notification')` must not win alone or the request
   * omits `cart-drawer` and the drawer never gets empty-state HTML / `is-empty`.
   */
  const getSectionsForCartRequest = () => {
    const ids = [];
    const seen = new Set();
    const pushFrom = (el) => {
      if (!el || typeof el.getSectionsToRender !== 'function') return;
      el.getSectionsToRender().forEach((s) => {
        if (s?.id && !seen.has(s.id)) {
          seen.add(s.id);
          ids.push(s.id);
        }
      });
    };
    pushFrom(document.querySelector('cart-drawer'));
    pushFrom(document.querySelector('cart-notification'));
    if (ids.length) return ids;
    return ['cart-drawer', 'cart-icon-bubble'];
  };

  const renderCartSectionsFromResponse = (parsedState) => {
    if (!parsedState?.sections) return;

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && parsedState.sections['cart-drawer']) {
      try {
        drawer.renderContents(parsedState);
        const count =
          typeof parsedState.item_count === 'number'
            ? parsedState.item_count
            : Array.isArray(parsedState.items)
              ? parsedState.items.length
              : 0;
        drawer.classList.toggle('is-empty', count === 0);
      } catch (e) {
        console.error(e);
      }
    }

    const notification = document.querySelector('cart-notification');
    if (
      notification &&
      typeof notification.renderContents === 'function' &&
      parsedState.key &&
      (parsedState.sections['cart-notification-product'] || parsedState.sections['cart-notification-button'])
    ) {
      try {
        notification.renderContents(parsedState);
      } catch (e) {
        console.error(e);
      }
    }
  };

  const sumQtyForVariant = (items, variantId) => {
    if (!items?.length || variantId == null || variantId === '') return 0;
    const id = Number(variantId);
    return items.reduce((sum, line) => {
      if (Number(line.variant_id) !== id) return sum;
      return sum + (Number(line.quantity) || 0);
    }, 0);
  };

  const updateQtyDisplay = (qty) => {
    const n = Number(qty) || 0;
    if (qtyEl) {
      qtyEl.textContent = n > 0 ? String(n) : '';
      qtyEl.setAttribute('aria-hidden', n > 0 ? 'false' : 'true');
    }
    if (stepper) {
      stepper.classList.toggle('product-story-sticky__stepper--has-line-qty', n > 0);
    }
    if (decBtn) {
      const soldOut = decBtn.hasAttribute('data-story-sold-out');
      decBtn.disabled = soldOut || n < 1;
    }
    if (submitBtn) {
      const base = submitBtn.getAttribute('data-add-to-cart-label') || submitLabel?.textContent?.trim() || '';
      const increaseAria = submitBtn.getAttribute('data-aria-label-increase') || '';
      if (n > 0 && increaseAria) {
        submitBtn.setAttribute('aria-label', increaseAria);
      } else {
        submitBtn.setAttribute('aria-label', base);
      }
    }
    if (addLabelEl && submitBtn) {
      addLabelEl.textContent =
        submitBtn.getAttribute('data-add-to-cart-label') || submitLabel?.textContent?.trim() || '';
    }
  };

  const refreshCartQtyForCurrentVariant = () => {
    const variantInput = getVariantInput();
    const vid = variantInput?.value;
    if (!vid) {
      updateQtyDisplay(0);
      return;
    }
    const url = (window.routes && window.routes.cart_url) || '/cart';
    fetch(`${url}.js`)
      .then((r) => {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then((cart) => updateQtyDisplay(sumQtyForVariant(cart?.items, vid)))
      .catch(() => updateQtyDisplay(0));
  };

  const applyCartChangeAndSync = (line, quantity) => {
    const changeUrl = window.routes && window.routes.cart_change_url;
    if (!changeUrl || typeof fetchConfig === 'undefined') return Promise.resolve();

    const body = JSON.stringify({
      line,
      quantity,
      sections: getSectionsForCartRequest(),
      sections_url: window.location.pathname,
    });

    return fetch(changeUrl, { ...fetchConfig(), body })
      .then((response) => response.text())
      .then((text) => {
        const parsedState = JSON.parse(text);
        if (parsedState.errors) return;

        renderCartSectionsFromResponse(parsedState);

        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-story-sticky',
            cartData: parsedState,
            productVariantId: getVariantInput()?.value,
          });
        }
      });
  };

  const onDecClick = () => {
    const variantInput = getVariantInput();
    if (!decBtn || decBtn.disabled || !variantInput) return;
    const vid = variantInput.value;
    if (!vid) return;

    decBtn.classList.add('loading');
    decBtn.setAttribute('aria-busy', 'true');

    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(`${cartUrl}.js`)
      .then((r) => r.json())
      .then((cart) => {
        const idx = cart.items.findIndex((item) => Number(item.variant_id) === Number(vid));
        if (idx === -1) return;
        const line = idx + 1;
        const item = cart.items[idx];
        const nextQty = Math.max(0, (Number(item.quantity) || 0) - 1);
        return applyCartChangeAndSync(line, nextQty);
      })
      .catch(() => {})
      .finally(() => {
        decBtn.classList.remove('loading');
        decBtn.removeAttribute('aria-busy');
        refreshCartQtyForCurrentVariant();
      });
  };

  if (decBtn) decBtn.addEventListener('click', onDecClick);

  const syncFromVariantEvent = (event) => {
    const d = event?.data;
    if (!d || !d.variant) return;
    const mainId = getMainProductSectionId();
    if (!mainId || d.sectionId !== mainId) return;

    const variantInput = getVariantInput();
    if (variantInput) {
      variantInput.value = d.variant.id;
      variantInput.toggleAttribute('disabled', !d.variant.available);
    }

    if (priceEl && d.html) {
      const src = d.html.getElementById(`price-${mainId}`);
      if (src) priceEl.innerHTML = src.innerHTML;
      syncSubmitPriceFromPriceEl();
    }

    if (submitBtn && d.html) {
      const mainBtn = d.html.getElementById(`ProductSubmitButton-${mainId}`);
      const soldOut = mainBtn?.hasAttribute('disabled') ?? true;
      submitBtn.toggleAttribute('disabled', soldOut);
      submitBtn.toggleAttribute('data-story-sold-out', soldOut);
      if (decBtn) {
        decBtn.toggleAttribute('disabled', soldOut);
        decBtn.toggleAttribute('data-story-sold-out', soldOut);
      }
      const mainLabelSpan = mainBtn?.querySelector('span');
      if (submitLabel && mainLabelSpan) {
        const inner = mainLabelSpan.querySelector('.product-story-sticky__submit-text');
        submitLabel.textContent = inner ? inner.textContent : mainLabelSpan.textContent;
      }
      if (submitBtn && submitLabel) {
        submitBtn.setAttribute('data-add-to-cart-label', submitLabel.textContent.trim());
      }
      if (addLabelEl && submitLabel) {
        addLabelEl.textContent = submitLabel.textContent.trim();
      }
    }

    refreshCartQtyForCurrentVariant();
  };

  /**
   * Show the sticky bar as soon as the main add-to-cart button is no longer
   * visible in the viewport (scrolled away or covered). Hide it when the
   * button is actually visible again.
   */
  let stickyRaf = 0;
  let atcObserver = null;

  const isAtcVisibleToUser = (trigger) => {
    const rect = trigger.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const vw = window.innerWidth || document.documentElement.clientWidth;

    if (rect.bottom <= 0 || rect.top >= vh || rect.right <= 0 || rect.left >= vw) {
      return false;
    }

    const x = Math.min(vw - 1, Math.max(1, rect.left + rect.width / 2));
    const y = Math.min(vh - 1, Math.max(1, rect.top + rect.height / 2));
    const hit = document.elementFromPoint(x, y);
    if (!hit) return false;
    if (hit.closest('[data-product-story-sticky]')) return false;
    return trigger === hit || trigger.contains(hit);
  };

  const updateStickyVisibility = () => {
    const trigger = getAtcTrigger();
    if (!trigger) {
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
      return;
    }

    const stickyArmed = !isAtcVisibleToUser(trigger);

    root.classList.toggle('is-visible', stickyArmed);
    root.setAttribute('aria-hidden', stickyArmed ? 'false' : 'true');
  };

  const onScrollOrResize = () => {
    cancelAnimationFrame(stickyRaf);
    stickyRaf = requestAnimationFrame(updateStickyVisibility);
  };

  const observeAtc = () => {
    const trigger = getAtcTrigger();
    if (!trigger || typeof IntersectionObserver === 'undefined') return;

    if (atcObserver) atcObserver.disconnect();
    atcObserver = new IntersectionObserver(onScrollOrResize, {
      threshold: 0,
      root: null,
    });
    atcObserver.observe(trigger);
  };

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
  observeAtc();
  updateStickyVisibility();

  refreshCartQtyForCurrentVariant();
  syncSubmitPriceFromPriceEl();

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      syncFromVariantEvent(event);
      observeAtc();
      updateStickyVisibility();
    });
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      refreshCartQtyForCurrentVariant();
    });
  }
})();